
class CollisionHelper {
  constructor() {
    // temp vars
    this.tempX = 0;
    this.tempY = 0;
    this.tempR = 0;
  }

  // --------------------------------------------------------------
  // Circle
  // --------------------------------------------------------------

  hitCircle(posPt, hitData, scale = true) {
    this.tempX = posPt.x - aScene.iManager.stage.x;
    this.tempY = posPt.y - aScene.iManager.stage.y;
    this.tempR = scale ? hitData.hR * aPage.resizer.scaleMain : hitData.hR;
    return (Math.sqrt((this.tempX * this.tempX) + (this.tempY * this.tempY)) <= this.tempR);
  }

  // --------------------------------------------------------------
  // Rectangle
  // --------------------------------------------------------------

  hitRect(posPt, hitData) {
    this.tempX = aScene.iManager.stage.x - posPt.x;
    this.tempY = aScene.iManager.stage.y - posPt.y;

    return (
      this.tempX >= 0 &&
      this.tempX <= hitData.hW * aPage.resizer.scaleMain &&
      this.tempY >= 0 &&
      this.tempY <= hitData.hH * aPage.resizer.scaleMain
    );
  }
}

export default CollisionHelper;



// WEBPACK FOOTER //
// ./src/js/scene/helpers/CollisionHelper.js